module.exports = __webpack_public_path__ + "img/logo_login.9e9df912.svg";